import {
    FC, // exp_PORTFOLIO-58018_next_line
    ReactNode,
} from 'react';

import { CampaignProductType } from 'utils/constants/campaign';

import {
    Box,
    CheckableCard, // exp_PORTFOLIO-58018_next_line
    Flex,
    Skeleton,
    Text,
    VSpacing,
    VSpacingContainer,
} from '@hh.ru/magritte-ui';

import { setWizardSelectedProductType } from 'store/models/campaignCreationWizard';
import { useDispatch } from 'store/utils';

import IconCpc from 'components/CampaignCreationWizard/PromotionTypeStep/components/ProductTypeCard/icon-cpc.svg';
import IconHH from 'components/CampaignCreationWizard/PromotionTypeStep/components/ProductTypeCard/icon-hh.svg';

interface ProductTypeCardProps {
    productType: CampaignProductType;
    title: string;
    description: string;
    price: string;
    checked: boolean;
    active?: boolean;
    activeLabel?: string;
    isStatusLoading?: boolean;
    // exp_PORTFOLIO-58018_start
    tag?: ReactNode;
    isVrProductExist?: boolean;
    // exp_PORTFOLIO-58018_end
}

const ICON_CONFIG: Record<CampaignProductType, { src: string; width: number; height: number; alt: string }> = {
    [CampaignProductType.SearchAuction]: {
        src: IconHH,
        width: 24,
        height: 24,
        alt: 'hh.ru',
    },
    [CampaignProductType.Cpc]: {
        src: IconCpc,
        width: 96,
        height: 24,
        alt: 'hh.ru, VK, Яндекс и другие площадки',
    },
    // exp_PORTFOLIO-58018_start
    [CampaignProductType.Vr]: {
        src: IconHH,
        width: 24,
        height: 24,
        alt: 'hh.ru',
    },
    // exp_PORTFOLIO-58018_end
    // exp_PORTFOLIO-61587_start
    [CampaignProductType.VacancyOfTheDay]: {
        src: IconHH,
        width: 24,
        height: 24,
        alt: 'hh.ru',
    },
    // exp_PORTFOLIO-61587_end
};

export const ProductTypeCard: FC<ProductTypeCardProps> = ({
    productType,
    title,
    description,
    price,
    checked,
    active,
    activeLabel,
    isStatusLoading = false,
    // exp_PORTFOLIO-58018_start
    tag,
    isVrProductExist,
    // exp_PORTFOLIO-58018_end
}) => {
    const dispatch = useDispatch();

    const icon = ICON_CONFIG[productType];

    return (
        <CheckableCard
            padding={24}
            borderRadius={24}
            type="radio"
            value={productType}
            name="promotion-type"
            checked={checked}
            onChange={() => dispatch(setWizardSelectedProductType(productType))}
            data-qa={`promotion-type-card-${productType.toLowerCase()}`}
            flexible
            toneHover
        >
            <Flex direction="column" gap={8} grow={1} justify="space-between">
                <VSpacingContainer default={8}>
                    {/* exp_PORTFOLIO-58018_start */}
                    <Flex direction="row" justify="space-between" align="center" minHeight={28}>
                        <img src={icon.src} width={icon.width} height={icon.height} alt={icon.alt} />
                        {tag}
                    </Flex>
                    <VSpacing default={0} />
                    <Box minHeight={{ m: isVrProductExist ? '2lh' : '1lh', l: '1lh' }}>
                        <Text typography="subtitle-1-semibold">{title}</Text>
                    </Box>
                    {/* exp_PORTFOLIO-58018_end */}
                    <Text typography="label-3-regular" style="secondary">
                        {description}
                    </Text>
                </VSpacingContainer>
                <Skeleton width={96} height={22} borderRadius={8} loading={isStatusLoading}>
                    {active ? (
                        <Text typography="subtitle-1-semibold" style="positive">
                            {activeLabel}
                        </Text>
                    ) : (
                        <Text typography="subtitle-1-semibold">{price}</Text>
                    )}
                </Skeleton>
            </Flex>
        </CheckableCard>
    );
};
